export default __webpack_public_path__ + "static/media/logout_light.f8bf1561.svg";